"use strict";

exports.__esModule = true;
exports.default = void 0;

var _schema = _interopRequireDefault(require("../checklist/schema"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = {
  "type": "object",
  "properties": {
    "status": {
      "type": "string",
      "enum": ["new", "started", "closed"],
      "enumNames": ["Ny", "Påbegynt", "Avsluttet"],
      "default": "new"
    },
    "parentId": {
      "type": "number"
    },
    "documentType": {
      "type": "string",
      "default": "task"
    },
    "content": {
      "type": "object",
      "properties": {
        "status": {
          "type": "string",
          "enum": ["new", "started", "closed"],
          "enumNames": ["Ny", "Påbegynt", "Avsluttet"],
          "default": "new"
        },
        "title": {
          "type": "string"
        },
        "description": {
          "type": "string"
        },
        "priorityId": {
          "type": "number",
          "enum": [1, 2, 3],
          "enumNames": ["1. Høy", "2. Medium", "3. Lav"]
        },
        "collectionId": {
          "type": "string"
        },
        "checklist": _schema.default,
        "startedAt": {
          "type": "string",
          "format": "date"
        },
        "roles": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "personId": {
                "type": "primusPerson"
              },
              "role": {
                "type": "string"
              }
            }
          }
        },
        "completedAt": {
          "type": "string",
          "format": "date"
        },
        "media": {
          "type": "array",
          "items": {
            "type": "image"
          }
        }
      }
    }
  }
};
exports.default = _default;
module.exports = exports.default;